module.exports = __webpack_public_path__ + "static/media/remove_the_fitting50d74eb5ac194f87469fa6731ad1990f.webp";